//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Features -----------------------
import ChapterCardBook from 'components/ChapterBook';
//  -- Components ---------------------
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Star } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import * as Sentry from '@sentry/react';
import { Button as AntButton, Row } from "antd";
import DemoModal from 'components/DemoModal';
import { DeleteModal } from 'components/Dialog';
import Loading from 'components/Loading';
import Tag from 'components/Tag';
import { filter, find, get, has, map,  uniq } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useAllBook, useBookOrder } from "store/books/selectors";
import { useCurrentClass } from 'store/classes/selectors';
import { useCurrentOrg, useCurrentOrgPermission } from 'store/organizations/selectors';
import { handleHideOrShowParticularClassBooks, handleHideShowClassBooks, handleListUserClasses } from "store/userClasses/thunks";
import { useCurrentUser, useDemoStatus } from "store/users/selectors";
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import { storyData } from 'store/constants';
//  -- Constants ----------------------




//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const CustomCol = styled.div`
    margin: 0px;
    width: 100%;

    @media (min-width: 992px) {
        margin: ${p => p.margin};
        width: calc(50% - 12px);
    }
`;

const CustomRow = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (min-width: 992px) {
        flex-direction: row;
    }
`;

const ListItem = styled.li`
    margin: 11px 11px 11px;
    width:25%;
    max-width:150px;
    @media (min-width: 768px) {
      flex-shrink: 0;
    }
    @media only screen and (min-width: 600px) and (max-width: 800px) {
        width: calc(50% - 32px);
    }
    @media (min-width: 768px) and (max-width: 1600px){
      margin: 8px 8px 6px;
    }
    @media only screen and (max-width: 600px) {
        flex-direction: column;
        width: calc(50% - 32px);
    }
`
const List = styled.ul`
    height: auto;
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style-type: none;
    margin-bottom: 0px;
    @media (max-width: 1024px) or (orientation: landscape){
      padding-bottom: 10px;
    }
    @media (max-width: 992px) {
      width: 100%;
      margin-left: 0px;
    }
    @media (min-width: 768px) {
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: visible;
      -webkit-overflow-scrolling: touch;
    }
`;
const Section = styled.div`
    margin-bottom: 26px;
    position: relative;
    padding: 20px 11px;
    border: 1px solid #727272;
    border-radius: 8px;
    filter: drop-shadow(0px 0px 2.5px rgba(0, 0, 0, 0.26));
`;
const SectionTitle = styled.div`
    background: ${p=>p.bgColor?p.bgColor:'#00c4cc'};
    padding: 9px 8px;
    border-radius: 15px 15px 0px 0px;
    cursor: pointer;
    display: inline-block;
    min-width: 224px;
    text-align: center;
    margin-left: 32px;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
`;
const SectionSpecialTitle = styled.div`
    background: ${p=>p.bgColor?p.bgColor:'#00c4cc'};
    padding: 9px 8px;
    border-radius: 15px 15px 0px 0px;
    cursor: pointer;
    display: inline-block;
    min-width: 224px;
    text-align: center;
    margin-left: 32px;
    color: #FFF;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
`;
export const Wrapper = styled.div`
    width: 100%;
    @media (max-width: 1200px) {
        padding-bottom: 50px;
    }
`;

const WrapperChapterBook = styled.div`
    background-color: transparent;
    border: none;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    cursor: pointer;
    height: auto;
    outline: none;
    transition: all 300ms ease;
    width: 100%;
    position: relative;

    &:hover {
        box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }
`;


const Note = styled.span`
    color: ${COLOR.black400};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
`;
const HiddenBookSection = styled.div`

`;

//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
//
//  Chapter management
//
//  -- Description
//  Activity and quiz management for selected chapter
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const ChapterManagementBook = ({ org_books_group }) => {
    const dispatch = useDispatch();
    const booksAllList = useAllBook()
    const currentOrg = useCurrentOrg()
    const [modalOpen, toggleModal] = useState(false);
    const bookOrder = useBookOrder()
    const currentUser = useCurrentUser();
    const navigate = useNavigate();
    const demoStatus = useDemoStatus()
    const currentClass = useCurrentClass();
    const hasClass = !!has(currentClass, 'id');
    const [archiveToggle,setArchiveToggle] = useState(false)
    const [onArchiveLoading,setOnArchiveloading] = useState(false)
    const [group_to_Archive_dearchive,setGroupToArchive_dearchive] = useState([])
    const [isArchive,setIsArchive] = useState(false)
    const [showHiddentBooks,setShowHiddentBooks] = useState(false);
    const [loading,setLoading] = useState({bookId: "", loading: false , group:''});
    const [hideShowBookToggle, setHideShowBookToggle] = useState(false);
    const [hideShowBookPending, setHideShowBookPending] = useState(null);
    const orgPermissions = useCurrentOrgPermission();
    const archived_group = useMemo(() => currentClass.archived_group || [], [currentClass])
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768); // Adjust the width based on your mobile breakpoint
        };
       
        // Check the screen size on initial load
        handleResize();
       
        // Add resize event listener
        window.addEventListener('resize', handleResize);
       
        // Clean up event listener
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
   
      
    const orderedBook = useMemo(() => {
        let order_group = [];
        const books_group_permission = get(orgPermissions, "books_group_permission", []);
        (bookOrder || []).forEach((order) => {
            const class_books_group = org_books_group&&org_books_group.length>0?org_books_group:currentClass.books_group || []
            if (archived_group.includes(order.key)) return null;
            if (books_group_permission.length == 0 || books_group_permission.includes(order.key)) {
                const has_book = find(class_books_group, k => k == order.key);
                if (has_book) {
                    const result = [...(order && order.order && order.order.map((chapter) => {
                            const book = find(booksAllList, ["id", chapter]);
                            if (book) {
                                return book;
                            }
                            return null;
                        }).filter(Boolean)), storyData]
                    order_group.push({
                        key: order.key,
                        title: order.title,
                        color: order.color,
                        books: result
                    })
                }
            }
        });
        return order_group;
    }, [currentClass, orgPermissions, booksAllList,org_books_group]);
    const hiddenOrderedBook = useMemo(() => {
        return bookOrder.map(k => {
            if (archived_group.find(f=>f==k.key)) {
                 const result = [
                    ...k.order.map((p) => find(booksAllList, (s) => s.id == p)).filter(Boolean),
                    storyData
                ];
                return ({
                    ...k,
                    books: result
                })
            }
            return null;
        }).filter(Boolean)

    }, [bookOrder, booksAllList, currentClass]);
      

    const handleSetChapter = ((chapter,key) => {
        localStorage.setItem('active_group', key);
        const demoPages = get(find(booksAllList, ["id", chapter]), "demoPages")
        if (demoStatus && demoPages && demoPages.from>=0) {
            navigate(`/ebook?chapter=${chapter}&page=${demoPages.from}&activity=null&quiz=null`);
        } else {
            navigate(`/ebook?chapter=${chapter}&page=1&activity=null&quiz=null`);
        }
    });




    useEffect(() => {
        if (currentClass.archived_group?.length == 0) {
            setShowHiddentBooks(false);
        }
    }, [currentClass])


    const getBookDesc = ((bookId) => {
        try{
            if (Array.isArray(booksAllList)) {
                const bookD = filter(booksAllList, x => x.id == bookId);
                return bookD[0].description;
            } else {
                return ""
            }
        }catch(error){
            Sentry.captureException(error, {
                extra: {
                    bookId: bookId,
                    booksAllListLength: booksAllList?.length,
                    booksAllListType: typeof booksAllList,
                    errorLocation: 'getBookDesc',
                    errorMessage: error?.message,
                    stack: error?.stack
                },
                tags: {
                    feature: 'ChapterManagementBook',
                    action: 'getBookDescription'
                }
            });
        }
    });
    const getIsOnlYTeacher = (bookId) => {
        if (Array.isArray(booksAllList)) {
            const bookD = find(booksAllList, x => x.id == bookId);
           return  bookD?.onlyTeacher
        }
        return false;
    };
    const onArchiveDone = async() =>{
        setOnArchiveloading(true);
        let archived_group = [];
        const class_archived_group = get(currentClass,"archived_group",[])
        if(isArchive){ 
            archived_group = filter(class_archived_group,k=>k!=group_to_Archive_dearchive)
        }else{
            archived_group  = uniq([...class_archived_group,group_to_Archive_dearchive])
        }
       await dispatch(handleHideShowClassBooks(currentClass.userBookId,archived_group,currentClass.id))
       await dispatch(handleListUserClasses(currentUser.id))
       setOnArchiveloading(false);
       setArchiveToggle(false)
    }

    const handleHideShowBook = async (bookId, value,group) => {
      try {
        setLoading({bookId, loading: true , group});
        const payload = {
          id: currentClass.userBookId,
          bookId,
          action: value ? "show" : "hide",
          group:group
        };
        await dispatch(
          handleHideOrShowParticularClassBooks(payload, currentClass?.id)
        );
      } catch (error) {
        Sentry.captureException(`517 Error in handleHideShowBook: ${error}`);
        console.log(error);
      } finally {
        setLoading({bookId: "", loading: false , group:''});
      }
    };

    const setHideShowBookModalOpen = useCallback((open) => {
      setHideShowBookToggle(Boolean(open));
      if (!open) setHideShowBookPending(null);
    }, []);

    const confirmHideShowBook = async () => {
      if (!hideShowBookPending) return;
      const { bookId, willShow, group } = hideShowBookPending;
      await handleHideShowBook(bookId, willShow, group);
      setHideShowBookModalOpen(false);
    };

    const isHiddenBook = useCallback((bookId, group) => {
        const list_hiddent_book = get(currentClass, "hide_books", []);
        const hiddenlist = filter(list_hiddent_book, k => k.bookId == bookId);
        if (hiddenlist.length > 0) {
            const has_group = filter(hiddenlist, k => k.group);
            if (has_group.length > 0) {
                const has_in_group = find(has_group, k => k.group == group);
                return has_in_group ? true : false;
            } else {
                return true;
            }
        }
        return false;
    }, [currentClass]);
      const HiddenBook = ({ chapter  , group, disableHideShowBook = false}) => {
        const isLoading = loading?.bookId === chapter?.id  && loading.group === group
        const is_hidden = isHiddenBook(chapter?.id,group)
        if(chapter?.onlyTeacher){
            return null;
        }
        return (
          <>
            {get(currentUser, "role") == "teacher" && (
              <div className='ebookEyeBtn'>
                {isLoading ? (
                  <AntButton
                    className={"show-hide-book-home"}
                    icon={
                      <Loading
                        style={{ width: "20px", height: "20px", marginInline: "auto" }}
                      
                      />
                    }
                  />
                ) : (
                  <button
                    disabled={isLoading || disableHideShowBook}
                    className="show-hide-button"
                    style={{ cursor: disableHideShowBook ? "not-allowed" : "pointer" }}
                    onClick={(event) => {
                      event.stopPropagation();
                      setHideShowBookPending({
                        bookId: chapter.id,
                        willShow: is_hidden ? true : false,
                        group,
                      });
                      setHideShowBookToggle(true);
                    }}
                  >

                    {is_hidden ? (
                            <EyeInvisibleOutlined />
                          ) : (
                            <EyeOutlined />
                          )
                    }
                  </button>
                )}
              </div>
            )}
          </>
        );
      };

      const handleClickChapterBook = (chapter, bk, is_hidden) => {
        if(is_hidden && get(currentUser,"role")=='student'){
            return;
        }
        if(chapter?.key === "story"){
            navigate("/story-levels")
            return;
        }
        handleSetChapter(chapter.id, bk.key)
    }
    return (
        <Wrapper>
            <>
                <DemoModal
                    open={modalOpen}
                    handleClose={() => toggleModal(false)}
                    message={currentOrg?.demo ? 'Not available in demo' : 'Chapter is currently under maintenance'}
                />
                  <DeleteModal
                        deleteToggle={archiveToggle}
                        setDeleteToggle={setArchiveToggle}
                        loading={onArchiveLoading}
                        message={isArchive?`Are you sure you want to show  these books in  class?`:`If you hide these books, all assignments, grades, notes, and any changes made to the books will be hidden. Are you sure you want to hide these books?
                        `}
                        buttonTitle={isArchive?"Show":"Hide"}
                        onDelete={onArchiveDone}
                        colorSchema={isArchive?"primary":"secondary"}
                    />
                    <DeleteModal
                        deleteToggle={hideShowBookToggle}
                        setDeleteToggle={setHideShowBookModalOpen}
                        loading={
                          loading.loading &&
                          hideShowBookPending &&
                          loading.bookId === hideShowBookPending.bookId &&
                          loading.group === hideShowBookPending.group
                        }
                        message={
                          hideShowBookPending?.willShow
                            ? "Are you sure you want to show this book in class?"
                            : "Hiding this book will hide assignments, grades, notes, and changes for students. Are you sure you want to continue?"
                        }
                        buttonTitle={hideShowBookPending?.willShow ? "Show" : "Hide"}
                        onDelete={confirmHideShowBook}
                        colorSchema={hideShowBookPending?.willShow ? "primary" : "secondary"}
                    />
                {get(currentUser, "role") == 'teacher' && archived_group.length > 0 && <Button className='hideBookBtn' color={"primary"} size="small" style={{ marginBottom: 16 }} variant="contained" onClick={() => { setShowHiddentBooks(!showHiddentBooks) }} >{showHiddentBooks ? "Show books" : "Show hidden books"}</Button>}
                
                {/* // show all archive book that hide by teacher */}
                {showHiddentBooks && (get(currentClass,"archived_group.length",0)>0||showHiddentBooks) && 
                <HiddenBookSection>
                    <Row>
                        <Tag height={20} bgColor={COLOR.redishpink} ><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                        <Note style={{ color: COLOR.black100 }}>These are hidden books.</Note>
                    </Row>
                    {map(hiddenOrderedBook, (bk, i) => {
                        return (<div key={i}> {bk.title ? <SectionTitle bgColor="#1b2d4f">{bk.title}</SectionTitle> : null}
                          <Section className='ebookTeacherList'>
                            {hasClass && get(currentUser,"role")=='teacher'  && <Button className="addOnBtn" onClick={() => {
                                setGroupToArchive_dearchive(bk.key)
                                setIsArchive(true)
                                setArchiveToggle(true)
                            }} variant="contained" style={{ position: "absolute", top: "-19px", right: "8px" }} color="primary">Show</Button>}
                            <List className='ebookTeacherListUl'>
                                {map(bk.books, chapter => {
                                    if (!chapter || !chapter.id) return null;
                                    const is_hidden = isHiddenBook(chapter?.id,bk.title)
                                    return (
                                        <Tooltip color='black' key={chapter?.id+bk.title} title={`${get(currentUser,"role")=='student' &&is_hidden ? "The book is hidden by the teacher." : "" }`}>
                                        <ListItem style={{opacity: "0.6"}} key={chapter?.id} className='home-view-book'>  
                                                {chapter?.key !== "story" ? (
                                                   <WrapperChapterBook onClick={() => { }}>
                                                        <img style={{width: "100%"}} src={chapter.img} alt={chapter.description} loading="eager" decode="sync" fetchPriority="high" />
                                                        <div style={{position: "absolute", bottom: 0, right: 0}}>
                                                            <HiddenBook chapter={chapter} group={bk.title} disableHideShowBook={true} />
                                                        </div>
                                                    </WrapperChapterBook>
                                                ): (
                                                    <ChapterCardBook data={chapter} handleClick={() => { }} />
                                                )}
                                            <div className="bookName cursor-pointer"><span>{chapter?.key === "story" ? chapter?.title :getBookDesc(chapter.id)}</span></div>
                                        </ListItem>
                                        </Tooltip>
                                    )
                                })}
                            </List>
                        </Section> </div>)
                    })}
                </HiddenBookSection>
                }
    
                {!showHiddentBooks? map(orderedBook, (bk,i) => { 
                    // For students, check if there are any visible books in this group
                    const visibleBooks = bk.books.filter(chapter => {
                        if (!chapter || !chapter.id) return false;
                        const is_hidden = isHiddenBook(chapter?.id,bk.title)
                        const bk_onlyTeacher = getIsOnlYTeacher(chapter?.id)
                        if(get(currentUser, "role") == "student" && bk_onlyTeacher){
                            return false;
                        } 
                        if(get(currentUser, "role") == "student" && is_hidden){
                            return false;
                        }
                        return true;
                    });

                    // If student has no visible books in this group, don't render the section at all
                    if(get(currentUser, "role") == "student" && visibleBooks.length === 0) {
                        return null;
                    }

                    return(<div key={i}> 
                       {bk.title ? (
                            bk.title === 'America Ed. 4 - AP Span Lang' && isMobile ? (
                            <SectionSpecialTitle bgColor={bk.color}>{bk.title}</SectionSpecialTitle>
                            ) : (
                            <SectionTitle bgColor={bk.color}>{bk.title}</SectionTitle>
                            )
                        ) : null}  

                   <Section className='ebookTeacherList'>
                   {hasClass&&get(currentUser,"role")=='teacher'&&<Button className="addOnBtn" onClick={()=>{
                        setGroupToArchive_dearchive(bk.key)
                        setIsArchive(false)
                        setArchiveToggle(true)
                    }} variant="contained" style={{position:"absolute",top:"-19px",  right:"8px"}} color="primary">{"Hide"}</Button>}
                    <List className='ebookTeacherListUl'>
                       
                        {map(bk.books, chapter => {
                            if (!chapter || !chapter.id) return null;
                            const is_hidden = isHiddenBook(chapter?.id,bk.title)
                            const bk_onlyTeacher = getIsOnlYTeacher(chapter?.id)
                            if(get(currentUser, "role") == "student" && bk_onlyTeacher){
                                return null;
                            } 
                            if(get(currentUser, "role") == "student" && is_hidden){
                                return null;
                            }
                            return (
                                <Tooltip color='black' key={chapter?.id+bk.title} title={`${get(currentUser,"role")=='student' && is_hidden ? "The book is hidden by the teacher." : "" }`}>
                                <ListItem style={{opacity: is_hidden ? "0.6" : "1"}} className='home-view-book' key={chapter?.id}>
                                    {chapter?.key !== "story" ? (
                                        <WrapperChapterBook onClick={() => {
                                            handleClickChapterBook(chapter, bk, is_hidden)
                                            }}>
                                            <img style={{width: "100%"}} src={chapter.img} alt={chapter.description} loading="eager" decode="sync" fetchPriority="high" />
                                            <div style={{position: "absolute", bottom: 0, right: 0}}>
                                                <HiddenBook chapter={chapter} group={bk.title} />
                                            </div>
                                        </WrapperChapterBook>
                                    ): (
                                        <ChapterCardBook  data={chapter} handleClick={() => {
                                        handleClickChapterBook(chapter, bk, is_hidden)
                                        }} />
                                    )}
                                    <div onClick={() => {
                                         handleClickChapterBook(chapter, bk, is_hidden)
                                    }} className="bookName 222 cursor-pointer"><span>{chapter?.key === "story" ? chapter?.title : getBookDesc(chapter.id)}</span></div>
                                </ListItem>
                                </Tooltip>
                            )
                        })}
                    </List>
                </Section></div>)}):null}
            </>
        </Wrapper>
    );
};


export default ChapterManagementBook;
